import EmailIcon from '@mui/icons-material/Email';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Avatar, Box, Button, styled, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useStaticLinks } from 'probonio-shared-ui/module/links/hooks';
import { normalizeWa } from 'probonio-shared-ui/utils/normalize';
import { Trans, useTranslation } from 'react-i18next';
import { BasicDialog, DialogState } from '../../component/dialog';
import support1 from './support1.jpeg';
import support2 from './support2.jpeg';
import support3 from './support3.jpeg';

const SupportAvatar = styled(Avatar)(({ theme }) => ({
  width: 94,
  height: 94,
  padding: 4,
  backgroundColor: '#fff',
  marginLeft: -20,
  '>img': {
    borderRadius: '100%',
  },
}));

export const SupportDialogProbonio: React.FC<{ dialogState: DialogState }> = ({ dialogState }) => {
  const { t } = useTranslation('homePage');
  const links = useStaticLinks();

  return (
    <BasicDialog
      dialogState={dialogState}
      title={<Trans i18nKey="homePage:support.dialogTitle" />}
      content={
        <>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginLeft: 1 }}>
            <SupportAvatar src={support1} alt="" />
            <SupportAvatar src={support2} alt="" />
            <SupportAvatar src={support3} alt="" />
          </Box>
          <Box paddingTop={2}>
            <Typography variant="body1">{t('support.description')}</Typography>
          </Box>
          <Grid paddingTop={2} container>
            <Grid size={3} />
            <Grid size={6}>
              {links?.MANUAL && (
                <Button
                  variant="text"
                  target="_blank"
                  href={`${links?.MANUAL}`}
                  sx={{ justifyContent: 'flex-start', marginBottom: 1 }}
                  fullWidth
                  startIcon={<MenuBookIcon />}
                >
                  {t('support.manual')}
                </Button>
              )}
              {links?.WA && (
                <Button
                  variant="text"
                  href={`https://wa.me/${normalizeWa(links.WA)}`}
                  sx={{ justifyContent: 'flex-start', marginBottom: 1 }}
                  fullWidth
                  startIcon={<WhatsAppIcon />}
                >
                  {t('support.whatsApp')}
                </Button>
              )}
              {links?.MAIL && (
                <Button
                  variant="text"
                  href={`mailto:${links.MAIL}`}
                  startIcon={<EmailIcon />}
                  fullWidth
                  sx={{ justifyContent: 'flex-start', marginBottom: 1 }}
                >
                  {links.MAIL}
                </Button>
              )}
              {links?.TEL && (
                <Button
                  variant="text"
                  href={`tel:${links.TEL.replace(/\s/g, '')}`}
                  startIcon={<PhoneIcon />}
                  fullWidth
                  sx={{ justifyContent: 'flex-start', marginBottom: 0.5 }}
                >
                  {links.TEL}
                </Button>
              )}
            </Grid>
            <Grid size={3} />
          </Grid>
        </>
      }
    />
  );
};
